
import React, { useEffect } from 'react';
import {  Button } from '@material-ui/core';

const TermsConditions = () => {
    return (
        <>
            <div className="container-fluid contact mt-3">
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row">
                            <div className="col-md-12 mt-1">
                                {/* <Alert severity="info">
                                    {'TERMS STATEMENT'}<br />
                                    {'Datum: 09-DEC-2021'}
                                </Alert> */}
                            </div>
                            <div className="col-md-10 mt-5 fontStyle fontStyleTerms">
                                <h2>Terms and Conditions</h2>

                                <p>Welcome to Kaipsool Pharmatech Pvt Ltd. By using our website and mobile application, you agree to adhere to the following Terms and Conditions. Please read these terms carefully.</p>
                                
                                <h5 className="mt-4 mb-3">User Agreement:</h5>
                                <ol>
                                     <li>Acceptance of Terms: By using Kaipsool Pharmatech Pvt Ltd, you agree to comply with these Terms and Conditions and any applicable laws and regulations. If you do not agree with these terms, please refrain from using our services.</li>
                                    <li>User Responsibilities: You are responsible for any activity conducted through your account. Please keep your login information secure and confidential.</li>
                                    <li>Legal Compliance: You must comply with all local, national, and international laws and regulations while using our platform.</li>
                                </ol>

                                <h5 className="mt-4 mb-3">Use of Our Services:</h5>
                                <ol>
                                    <li>Informational Platform: Kaipsool Pharmatech Pvt Ltd is an informational platform. We provide information about the availability of medicines and discounts at nearby medical shops, as well as facilitate the purchase of event tickets.</li>
                                    <li>No Product Sales: We do not physically deliver or sell any medicines or medical products. Users must contact medical stores directly for purchases.</li>
                                    <li>Event Tickets: We offer event tickets for pharmaceutical events and health camps. The purchase and use of event tickets are subject to our Cancellation and Refund Policy.</li>
                                </ol>

                                <h5 className="mt-4 mb-3">Intellectual Property:</h5>
                                <ul>
                                    <li>All content on our platform, including text, images, logos, and software, is protected by copyright and other intellectual property rights. You may not use, reproduce, or distribute any of our content without our explicit consent.</li>
                                </ul> 

                                <h5 className="mt-4 mb-3">Privacy and Data Protection:</h5>
                                <ul>
                                    <li>Please review our Privacy Policy to understand how we collect, use, and protect your personal information.</li>
                                </ul>    

                                <h5 className="mt-4 mb-3">Limitation of Liability:</h5>
                                <ul>
                                    <li>Kaipsool Pharmatech Pvt Ltd is not liable for any direct, indirect, or consequential damages arising from the use of our platform. We do not guarantee the accuracy, availability, or reliability of the information provided.</li>
                                </ul>  

                                <h5 className="mt-4 mb-3">Changes to Terms:</h5>
                                <ul>
                                    <li>We reserve the right to update these Terms and Conditions to reflect changes in our services or legal requirements. Users are encouraged to review these terms periodically for any updates.</li>
                                </ul>     

                                <h5 className="mt-4 mb-3">Termination:</h5>
                                <ul>
                                    <li>We may terminate or suspend user accounts if they violate these Terms or engage in prohibited activities.</li>
                                </ul>     

                                <h5 className="mt-4 mb-3">Contact us for any query:</h5>
                                <div className="contact-info-content">
                                    <p>Kaipsool Pharmatech Pvt Ltd<br/>  Agamkuan, Chhoti-Pahari,<br /> Patna-800026, <br/>
                                    <a href="tel:+91 9122249915">+91 9122249915</a></p>
                                </div>


                                <br />
                                

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TermsConditions
